import { Box, Button, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { useSlate } from 'slate-react'

import { InputText } from '../../Form/styled'
import ModalV3 from '../../Modal/ModalV3'
import { getActiveImageWidth, removeImage, setImageWidth } from './image'

export default function ResizeImageModal({
  showModal,
  setShowModal,
}: {
  showModal: boolean
  setShowModal: (show: boolean) => void
}): React.ReactElement {
  const editor = useSlate()
  const [currentSize, setCurrentSize] = React.useState(getActiveImageWidth(editor))
  return (
    <ModalV3
      size="lg"
      title="Resize Image"
      open={showModal}
      onClose={() => {
        setShowModal(false)
      }}
      rightFooterContent={() => (
        <Stack justify="flex-end" spacing={2} direction="row" mt={4}>
          <Button
            variant="danger-outline"
            onClick={() => {
              removeImage(editor)
              setShowModal(false)
            }}
          >
            Remove
          </Button>
          <Button
            onClick={() => {
              setImageWidth(editor, currentSize)
              setShowModal(false)
            }}
          >
            Save
          </Button>
        </Stack>
      )}
      body={() => (
        <Box>
          <Text fontWeight="bold" mb={2}>
            Please enter an image width (in pixels):
          </Text>
          <InputText
            type="number"
            value={currentSize ?? undefined}
            placeholder="100"
            onInput={e => setCurrentSize((e.target as HTMLInputElement).valueAsNumber)}
          />
        </Box>
      )}
    />
  )
}
